import { LOGIN_TOKEN } from '@ext-interfaces/app-data.model';
import { v4 as uuidv4 } from 'uuid';
import { Injectable } from "@angular/core";

@Injectable()
export class TokenService {
    constructor() {}

    getToken() {
        const token = localStorage.getItem(LOGIN_TOKEN);
        if (token) {
            return token;
        }
        const uuid = uuidv4();
        localStorage.setItem(LOGIN_TOKEN, uuid);

        return uuid;
    }

    saveTokenInLocalStorage(storageName: string, value: string) {
        localStorage.setItem(storageName, value);
    }
}
